import { useState } from "react";
import {
  submitSelectionFeedback,
  type BabyAIMoshPitResult,
} from "../lib/babyai-client";
import { MD } from "./Markdown";

interface Props {
  result: BabyAIMoshPitResult;
  /** Fires when the user accepts a choice (locks the assistant turn). */
  onAccept: (provider: string, content: string) => void;
}

export function MoshPitChoices({ result, onAccept }: Props) {
  const [activeIdx, setActiveIdx] = useState(0);
  const [accepted, setAccepted] = useState(false);

  const active = result.alternatives[activeIdx];

  function pick(idx: number) {
    setActiveIdx(idx);
  }

  function accept() {
    if (accepted) return;
    const alt = result.alternatives[activeIdx];
    submitSelectionFeedback({
      requestId: result.requestId,
      selectedProvider: alt.provider,
      allProviders: result.allProviders,
    });
    setAccepted(true);
    onAccept(alt.providerName, alt.content);
  }

  if (accepted) {
    return (
      <div className="msg assistant">
        <div className="msg-meta">
          <span className="author">{active.providerName}</span>
          <span>{active.modelId}</span>
        </div>
        <div className="msg-body"><MD>{active.content}</MD></div>
      </div>
    );
  }

  return (
    <div className="mosh-pit">
      <div className="mosh-tabs">
        {result.alternatives.map((alt, i) => (
          <button
            key={i}
            className={`mosh-tab ${i === activeIdx ? "active" : ""}`}
            onClick={() => pick(i)}
            title={alt.modelId}
          >
            {alt.preferred && <span className="preferred">★</span>}
            {alt.providerName}
          </button>
        ))}
      </div>
      <div className="mosh-body">
        <MD>{active.content}</MD>
        <div style={{ marginTop: 8, display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="btn btn-primary" onClick={accept}>
            Pick {active.providerName}
          </button>
        </div>
      </div>
    </div>
  );
}
